<div class="organization-modal modal-content" piqetAngularDraggable>
  <ng-container *ngrxLet="projectFacade.defalutMaterialProjectList$ as defalutMaterialProjectList">
    <div class="modal-header header-modal">
      <span class="bootstrap-dialog-title header-title">{{ modalLabel }} </span>
      <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>
    <div class="modal-body body-modal">
      <form [formGroup]="myProjectForm">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="projectName"
                [control]="myProjectForm.get('projectName')"
                label="Project name"
                placeholder="Project name"
                [maxLength]="100"
                [submitted]="submitted"
                [preventDot]="true"
                (customBlur)="getProjectname($any(myProjectForm.get('projectName')?.value))"
              >
              </piqet-angular-common-input>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="projectNameForReport"
                [control]="myProjectForm.get('projectNameForReport')"
                label="Project name used in report"
                placeholder="Project name used in report"
                [maxLength]="300"
                [preventDot]="true"
                [submitted]="submitted"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!myProjectData.isMember && !myProjectData.isCustomItem">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group">
              <label
                *ngIf="myProjectForm.get('organizationName')?.value"
                class="sub-header-drpdown pb-2"
                >Organization</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                [items]="organizationlist"
                [searchable]="false"
                bindLabel="name"
                #organization
                formControlName="organizationName"
                [searchFn]="commonInputSearch"
                placeholder="Organization"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      placeholder="Search..."
                      (input)="organization.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback"><i class="fa fa-search icon"></i></span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div class="form-group required">
              <label *ngIf="myProjectForm.get('share')?.value" class="sub-header-drpdown pb-2"
                >Share</label
              >
              <label
                *ngIf="!myProjectForm.get('share')?.value && myProjectForm.get('status')?.value"
                class="placeholder-sub-header pb-2"
                >Holder_text</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #share
                [items]="shareItems"
                bindLabel="name"
                [searchable]="false"
                formControlName="share"
                [searchFn]="commonInputSearch"
                placeholder="Share"
                (change)="selectTeam($event)"
              >
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (myProjectForm.controls['share']?.touched &&
                    myProjectForm.controls['share']?.invalid) ||
                  (submitted && !myProjectForm.controls['share'].value?.name)
                "
                class="input-error"
              >
                Share is required
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div class="form-group required">
              <label *ngIf="myProjectForm.get('status')?.value" class="sub-header-drpdown pb-2"
                >Status</label
              >
              <label
                *ngIf="myProjectForm.get('share')?.value && !myProjectForm.get('status')?.value"
                class="placeholder-sub-header pb-2"
                >Holder_text</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #status
                [items]="projectStatusList"
                [searchable]="false"
                bindLabel="name"
                bindValue="id"
                formControlName="status"
                [searchFn]="commonInputSearch"
                placeholder="Status"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      (input)="status.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isShowTeamList">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group">
              <label *ngIf="myProjectForm.get('team')?.value" class="sub-header-drpdown pb-2"
                >Team</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #share
                [items]="teamList"
                bindLabel="name"
                [searchable]="false"
                formControlName="team"
                [searchFn]="commonInputSearch"
                placeholder="Select Team *"
              >
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (myProjectForm.controls['team']?.touched &&
                    myProjectForm.controls['team']?.invalid) ||
                  (submitted && !myProjectForm.controls['team'].value?.name)
                "
                class="input-error"
              >
                Team is required
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required">
              <label
                *ngIf="myProjectForm.get('defaultCountry')?.value"
                class="sub-header-drpdown pb-2"
                >Country</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #defaultCountry
                [items]="defaultRegionItems"
                [searchable]="false"
                bindLabel="name"
                formControlName="defaultCountry"
                [searchFn]="commonInputSearch"
                placeholder="Select default country where most of the processes will be carried out."
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      (input)="defaultCountry.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (myProjectForm.controls['defaultCountry']?.touched &&
                    myProjectForm.controls['defaultCountry']?.invalid) ||
                  (submitted && !myProjectForm.controls['defaultCountry'].value?.name)
                "
                class="input-error"
              >
                Country is required
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group">
              <div class="services-form">
                <textarea
                  formControlName="description"
                  cols="20"
                  id="Description"
                  name="Description"
                  rows="2"
                  placeholder="Description"
                ></textarea>
                <label>Goal and scope</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group">
              <div class="services-form">
                <textarea
                  formControlName="boundryJustification"
                  cols="20"
                  id="boundryJustification"
                  name="boundryJustification"
                  rows="2"
                  placeholder="Description"
                ></textarea>
                <label>System boundary justification</label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
      <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
    </div>
  </ng-container>
</div>
